// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6001) return "static/chunks/6001-29b8103325d092ef.js";
	if (chunkId === 3309) return "static/chunks/3309-17ea5ab63567a507.js";
	if (chunkId === 3452) return "static/chunks/3452-43853b0054846892.js";
	if (chunkId === 3218) return "static/chunks/3218-e0a7e5def00eafd9.js";
	if (chunkId === 244) return "static/chunks/244-26dd7bdc4f1d57a3.js";
	if (chunkId === 441) return "static/chunks/441-833d8493eaabb66b.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8513 ? "58474bfb" : chunkId) + "." + {"368":"a4488915d6e0ca5e","838":"64813a3fe82ebecb","1589":"c3bbd7725e2151e1","2146":"54f2f7a75b9b6cad","4845":"803ced9250105cbd","5687":"844fc3a2eab572bd","7088":"caa76fd7b673d909","7557":"152ce2c323b44181","8073":"401c443055a54fcf","8513":"528a3aabb9ba4b19","9167":"cca5818fc6910926","9305":"0de62c049636ce39"}[chunkId] + ".js";
};